export default __webpack_public_path__ + "static/media/2_icon3B.1ec71b3d.png";